<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mt-5 cursor-pointer" :class="{show: expanded}" @click="toggle">
            <h3>Instellingen</h3>
            <i class="far fa-angle-down lead"></i>
        </div>
        <transition-slide-toggle>
            <form @submit.prevent="submit" novalidate v-show="expanded" class="accordion-body">
                <div class="row">
                    <div class="col-12 col-md-6 mb-4">
                        <p>Wilt u alerts ontvangen?</p>
                        <div class="custom-control custom-radio small">
                            <input type="radio" value="1" class="custom-control-input" id="alert-yes" v-model.trim="$v.form.alerts.$model">
                            <label class="custom-control-label grey" for="alert-yes">Ja, ik wil alerts ontvangen</label>
                        </div>
                        <div class="custom-control custom-radio small">
                            <input type="radio" value="0" class="custom-control-input" id="alert-no" v-model.trim="$v.form.alerts.$model">
                            <label class="custom-control-label grey" for="alert-no">Nee, ik wil geen alerts ontvangen</label>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mb-4">
                        <p>Wilt u de nieuwsbrief ontvangen?</p>
                        <div class="custom-control custom-radio small">
                            <input type="radio" value="1" class="custom-control-input" id="newsletter-yes" v-model.trim="$v.form.newsletter.$model">
                            <label class="custom-control-label grey" for="newsletter-yes">Ja, ik wil de nieuwsbrief ontvangen</label>
                        </div>
                        <div class="custom-control custom-radio small">
                            <input type="radio" value="0" class="custom-control-input" id="newsletter-no" v-model.trim="$v.form.newsletter.$model">
                            <label class="custom-control-label grey" for="newsletter-no">Nee, ik wil geen nieuwsbrief ontvangen</label>
                        </div>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary btn-caret btn-sm mr-4 mb-3 mb-md-0" ref="btn">Gegevens aanpassen</button>
            </form>
        </transition-slide-toggle>
    </div>
</template>

<script>
    export default {
        props: {
            data: Object,
            btnStartLoading: Function,
            btnFinishLoading: Function,
        },
        data() {
            return {
                expanded: false,
                form: {
                    alerts: this.data.alerts,
                    newsletter: this.data.newsletter,
                },
            }
        },
        validations: {
            form: {
                alerts: {},
                newsletter: {},
            }
        },
        methods: {
            submit() {
                this.$refs.btn.blur();
                this.$v.$touch();

                if (this.$v.$anyDirty && !this.$v.$invalid) {
                    this.btnStartLoading(this.$refs.btn);

                    let that = this;
                    this.axios.post('/users/settings', this.form).then(() => {
                        that.$notify({
                            group: 'base',
                            text: 'Uw instellingen zijn opgeslagen.',
                            type: 'alert-info',
                        });

                        that.btnFinishLoading(this.$refs.btn, true);
                    }).catch(error => {
                        that.$notify({
                            group: 'base',
                            text: 'Er is een fout opgetreden.',
                            type: 'alert-danger',
                        });

                        that.btnFinishLoading(this.$refs.btn);

                        console.error(error);
                    });
                }
            },
            toggle() {
                this.expanded = !this.expanded;
            },
        }
    }
</script>
